import { ChangeEvent, useState, FC } from "react"
import s from "../UpdateStoks.module.css"
import { useAppDispatch } from "../../../../app/hooks"
import { Modal } from "../../../../features/Modal/Modal"
import { StatusInfo } from "../../../UpdateStoksIcon/StatusInfo/StatusInfo"
import {
  deleteSamsonWbRecode,
  samsonWbUpdateStocks,
  uploadSamsonWbRecode,
} from "../../../../app/reducers/updateStocksSamson"
import { TipSamson } from "./tip"
import { downloadSamsonRecode, parseSamsonRecode } from "./recode"
import { getWbSamsonLogData } from "../../helpers"
import { LogButton } from "../../../LogButton/LogButton"
import { STATUS } from "../../../../utils/const"
import BaseApi from "../../../../api/api"
import { NotificationService } from "../../../../features/NotificationService/NotificationService"
import { StorageSelectControl } from "../../../StorageSelect/StorageSelectControl"
import { MARKETPLACE } from "@acc/shared"
import { getMessage } from "../../../../msgs/msgs"
import { ObjectRenderer } from "../../../ObjectViewer/ObjectViewer"
import { StocksTable } from "../../../ObjectViewer/ObjectTableViewer"
import { Checkbox, Button } from "@radix-ui/themes"

type StocksContentProps = {
  updateStoksState: {
    lastStocksUpdated: string
    lastPricesUpdated: string
    status: STATUS
    isExistRecode: boolean
    errors?: { type: string; errors: any[] }[]
  }
  storages: {
    name: string
    officeId: number
    id: number
  }[]
}

const resetStocks = async (selectedStorageId: string) => {
  const response = await BaseApi.samsonWbResetStocks(selectedStorageId)
  if (response.data) {
    NotificationService.showNotification({
      message: response.data.message,
      level: (response.data.success && "success") || "error",
    })
  }
}

export const UpdateWbStocksTab: FC<StocksContentProps> = ({
  storages,
  updateStoksState,
}) => {
  const dispatch = useAppDispatch()
  const [selectedStorageId, setSelectedStorages] = useState("")
  const [isOpenModalUpdatePrices, setOpenModalUpdatePrices] = useState(false)
  const [isOpenModalResetStocks, setOpenModalResetStocks] = useState(false)
  const [updatePrices, setUpdatePrices] = useState(false)
  const [updateStocks, setUpdateStocks] = useState(false)
  const [isOpenErrModal, setOpenErrModal] = useState(false)
  const {
    lastStocksUpdated,
    lastPricesUpdated,
    status,
    isExistRecode,
    errors,
  } = updateStoksState || {}

  const handleUpdate = () => {
    if ((updatePrices || updateStocks) && isExistRecode && selectedStorageId) {
      setOpenModalUpdatePrices(true)
    }
  }

  const onResetClick = () => {
    if (isExistRecode && selectedStorageId) {
      setOpenModalResetStocks(true)
    }
  }

  return (
    <div>
      {lastPricesUpdated && (
        <h6>
          Последнее обновление цен:{" "}
          {new Date(lastPricesUpdated).toLocaleString()}
        </h6>
      )}
      {lastStocksUpdated && (
        <h6>
          Последнее обновление остатков:{" "}
          {new Date(lastStocksUpdated).toLocaleString()}
        </h6>
      )}
      <div className="flex flex-column flex-align-center flex-justify-center">
        {status && (
          <h6>
            статус: <StatusInfo status={status} />
          </h6>
        )}
        {(errors?.length && (
          <div className="flex gap-20">
            <StatusInfo
              status={STATUS.WARN}
              value="При обновлении были пропущены ошибки"
            />
            <Button onClick={() => setOpenErrModal(true)} color="red">
              посмотреть ошибки
            </Button>
          </div>
        )) ||
          null}
      </div>

      <div className={s.uploadFileWrap}>
        {isExistRecode ? (
          <div className={s.uploadedWrap}>
            <Button
              onClick={() => {
                dispatch(deleteSamsonWbRecode())
              }}
            >
              Удалить файл перекодировки
            </Button>
            <Button onClick={downloadSamsonRecode}>
              Скачать перекодировку
            </Button>
          </div>
        ) : (
          <div>
            <Button asChild>
              <label htmlFor={s.ktrnFileInp}>
                Загрузить файл перекодировки
                <input
                  style={{ display: "none" }}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    const file = e.target.files?.[0]
                    if (file) {
                      parseSamsonRecode(file).then((recode) => {
                        dispatch(uploadSamsonWbRecode(recode))
                      })
                    }
                  }}
                  type="file"
                  accept=".xlsx"
                  id={s.ktrnFileInp}
                />
              </label>
            </Button>
          </div>
        )}
        <TipSamson />
      </div>

      <StorageSelectControl
        label="Склад для обновления"
        value={selectedStorageId}
        onChange={(value) => {
          setSelectedStorages(value)
        }}
        controlKey="storages-select"
        marketplace={MARKETPLACE.WB}
      />
      <div className={s.checkboxContainer}>
        <label>
          <Checkbox
            checked={updatePrices}
            onCheckedChange={(value) => setUpdatePrices(value === true)}
          />
          Обновить цены
        </label>
        <label>
          <Checkbox
            checked={updateStocks}
            onCheckedChange={(value) => setUpdateStocks(value === true)}
          />
          Обновить остатки
        </label>
      </div>
      <Button
        className={s.updateButton}
        disabled={
          !isExistRecode ||
          !selectedStorageId ||
          (!updatePrices && !updateStocks)
        }
        onClick={handleUpdate}
      >
        Обновить
      </Button>
      <Button
        className={s.updateButton}
        disabled={!isExistRecode || !selectedStorageId}
        onClick={onResetClick}
      >
        Сбросить остатки на складе
      </Button>
      <LogButton getData={getWbSamsonLogData} />

      <Modal
        isOpen={isOpenModalUpdatePrices}
        header="Подтвердите действие. Обновление на Самсон ОПТ"
        content={`Обновить ${updatePrices ? "цены" : ""} ${
          updatePrices && updateStocks ? "и" : ""
        } ${updateStocks ? "остатки" : ""} для склада ${
          storages.find((el) => el.id === +selectedStorageId)?.name
        }`}
        onClose={() => setOpenModalUpdatePrices(false)}
        onOk={() => {
          selectedStorageId &&
            dispatch(
              samsonWbUpdateStocks({
                selectedStorageId,
                updatePrices,
                updateStocks,
              }),
            )
          setOpenModalUpdatePrices(false)
        }}
      />
      <Modal
        isOpen={isOpenModalResetStocks}
        header="Подтвердите действие. Сбросить остатки на Самсон ОПТ"
        content={`Сбросить остатки для склада ${
          storages.find((el) => el.id === +selectedStorageId)?.name
        }`}
        onClose={() => setOpenModalResetStocks(false)}
        onOk={() => {
          selectedStorageId && resetStocks(selectedStorageId)
          setOpenModalResetStocks(false)
        }}
      />
      <Modal
        isOpen={isOpenErrModal}
        header="Ошибки пропущенные при обновлении"
        onClose={() => setOpenErrModal(false)}
        onOk={() => setOpenErrModal(false)}
        size="auto"
        content={
          <div className="flex flex-column gap-20">
            {errors?.map((el) => {
              if (el.type === "UPLOAD_STOCKS") {
                return <StocksTable data={el} />
              }
              return (
                <div className="flex gap-20">
                  <b>{getMessage(el.type)}</b>
                  <ObjectRenderer data={el.errors} />
                </div>
              )
            })}
          </div>
        }
      ></Modal>
    </div>
  )
}
